// extracted by mini-css-extract-plugin
export default {"melodyVideo":"cJ-z","isFullWidth":"dJ-z","landingPageVideo":"eJ-z","play":"fJ-z","iframeVideo":"gJ-z","playHidden":"hJ-z","fullwidth":"iJ-z"};